import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

/** Checks elgibility for Mention On Restricted Page experiment. */
export function useIsMentionOnRestrictedPageEligible(): boolean {
	const { edition } = useSessionData();
	const isPaidEdition = edition !== ConfluenceEdition.FREE;

	// Must be paid edition
	if (!isPaidEdition) {
		return false;
	}

	return true;
}
